import { HashMap } from '@ngneat/transloco';

export interface TranslationId<T = any> {
  key: string;
  params?: HashMap<T>;
  scope?: string;
}

export function isTranslationId(value: unknown): value is TranslationId {
  return (
    typeof value === 'object' &&
    value !== null &&
    'key' in value &&
    typeof value.key === 'string' &&
    (!('params' in value) || value.params === undefined || typeof value.params === 'object') &&
    (!('scope' in value) || value.scope === undefined || typeof value.scope === 'string')
  );
}
